import { FC, SVGProps } from "react";
import { CommonIconProps } from "@madhive/kit-ui";

export const DashboardIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-campaign-dashboard"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path d="M12.75 6C12.75 5.58579 12.4142 5.25 12 5.25C11.5858 5.25 11.25 5.58579 11.25 6V6.5C11.25 6.91421 11.5858 7.25 12 7.25C12.4142 7.25 12.75 6.91421 12.75 6.5V6Z" />
      <path d="M8.28765 7.22702C7.99476 6.93413 7.51989 6.93413 7.22699 7.22702C6.9341 7.51992 6.9341 7.99479 7.22699 8.28768L7.58054 8.64123C7.87344 8.93413 8.34831 8.93413 8.6412 8.64123C8.9341 8.34834 8.9341 7.87347 8.6412 7.58057L8.28765 7.22702Z" />
      <path d="M5.25 12C5.25 11.5858 5.58579 11.25 6 11.25H6.5C6.91421 11.25 7.25 11.5858 7.25 12C7.25 12.4142 6.91421 12.75 6.5 12.75H6C5.58579 12.75 5.25 12.4142 5.25 12Z" />
      <path d="M16.75 12C16.75 11.5858 17.0858 11.25 17.5 11.25H18C18.4142 11.25 18.75 11.5858 18.75 12C18.75 12.4142 18.4142 12.75 18 12.75H17.5C17.0858 12.75 16.75 12.4142 16.75 12Z" />
      <path d="M16.773 8.28769C17.0659 7.9948 17.0659 7.51993 16.7731 7.22703C16.4802 6.93413 16.0053 6.93413 15.7124 7.22702L15.3588 7.58057C15.0659 7.87346 15.0659 8.34833 15.3588 8.64123C15.6517 8.93412 16.1266 8.93413 16.4195 8.64124L16.773 8.28769Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2408 15.1181C21.571 14.1391 21.75 13.0904 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 13.0904 2.42901 14.1391 2.75925 15.1181C2.77373 15.2097 2.80479 15.2957 2.84924 15.3731C4.22185 19.0955 7.80093 21.75 12 21.75C16.1991 21.75 19.7782 19.0955 21.1508 15.3731C21.1952 15.2957 21.2263 15.2097 21.2408 15.1181ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 12.78 3.85825 13.5348 4.06055 14.25H11.25V10C11.25 9.58579 11.5858 9.25 12 9.25C12.4142 9.25 12.75 9.58579 12.75 10V14.25H19.9395C20.1417 13.5348 20.25 12.78 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM19.3504 15.75H4.64956C6.0151 18.4213 8.79399 20.25 12 20.25C15.206 20.25 17.9849 18.4213 19.3504 15.75Z"
      />
    </svg>
  );
};

export const PacingIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-pacing"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.39349 3.78591C8.24824 3.7191 8.07739 3.74293 7.95597 3.84694C7.61208 4.14151 5.1512 6.24977 4.53185 6.7809C4.06712 7.17942 3.78475 7.75003 3.74978 8.36123C3.71481 8.97243 3.93026 9.57152 4.34649 10.0204C4.62359 10.3193 6.75927 12.618 8.82632 14.8427L12.8901 19.2163C12.8901 19.2163 12.8905 19.2167 12.3411 19.7272L12.8901 19.2163C13.5047 19.878 14.3677 20.2543 15.2708 20.2537C16.0856 20.2532 17.4513 20.2535 18.3914 20.2536C18.7344 20.2537 19.0207 20.2537 19.2029 20.2537C19.6009 20.2537 19.9648 20.0289 20.1428 19.6729C20.3207 19.3169 20.2823 18.8909 20.0435 18.5725L16.8022 14.2507C16.7538 14.1862 16.7162 14.1144 16.6907 14.0379L14.3867 7.12587C14.3626 7.05351 14.3068 6.99609 14.2352 6.96986C14.1636 6.94363 14.0839 6.95147 14.0188 6.99114L12.3903 7.98346C12.2727 8.05511 12.1376 8.09304 11.9999 8.09304H9.38184C9.18293 8.09304 8.99216 8.01402 8.8515 7.87336C8.71085 7.73271 8.63184 7.54194 8.63184 7.34302V4.15785C8.63181 3.99797 8.53874 3.85273 8.39349 3.78591ZM10.1319 6.59304L10.1318 4.15758C10.1317 3.41204 9.69767 2.73476 9.02036 2.42318C8.34304 2.11161 7.54633 2.22274 6.98012 2.70776C6.63638 3.00222 4.17513 5.11079 3.55539 5.64225C2.78102 6.30631 2.3105 7.2571 2.25223 8.27554C2.19395 9.29399 2.55296 10.2922 3.24654 11.0403C3.52434 11.3399 5.66094 13.6396 7.72744 15.8637L11.7913 20.2373C12.6899 21.2049 13.9513 21.7546 15.2718 21.7537C16.0859 21.7532 17.4503 21.7535 18.3903 21.7536C18.7336 21.7537 19.0203 21.7537 19.2029 21.7537C20.1691 21.7537 21.0523 21.2079 21.4844 20.3437C21.9165 19.4796 21.8232 18.4455 21.2435 17.6725L18.0752 13.4481L15.8098 6.65184C15.6413 6.14609 15.2516 5.74467 14.751 5.56135C14.2505 5.37803 13.6937 5.43279 13.2384 5.71012L11.7894 6.59304H10.1319Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.24618 17.5023C2.24618 17.0881 2.58197 16.7523 2.99618 16.7523H4.99702C5.41123 16.7523 5.74702 17.0881 5.74702 17.5023C5.74702 17.9165 5.41123 18.2523 4.99702 18.2523H2.99618C2.58197 18.2523 2.24618 17.9165 2.24618 17.5023Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.24618 21.0037C2.24618 20.5895 2.58197 20.2537 2.99618 20.2537H7.99827C8.41248 20.2537 8.74827 20.5895 8.74827 21.0037C8.74827 21.4179 8.41248 21.7537 7.99827 21.7537H2.99618C2.58197 21.7537 2.24618 21.4179 2.24618 21.0037Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.14109 6.07617C3.44461 5.79431 3.91916 5.81186 4.20103 6.11538L3.65146 6.62574L3.10189 7.13611C2.82002 6.83259 2.83757 6.35804 3.14109 6.07617ZM15.5254 18.7525C14.4835 18.755 13.488 18.322 12.7796 17.5581C12.4966 17.253 10.0774 14.6477 7.72853 12.1183L3.10189 7.13611C3.10189 7.13611 3.10189 7.13611 3.65146 6.62574C4.20103 6.11538 4.20103 6.11538 4.20103 6.11538L8.8277 11.0976C11.1762 13.6266 13.596 16.2325 13.8794 16.5381C14.3033 16.9952 14.899 17.2542 15.5223 17.2525L15.5244 17.2525L20.5505 17.2525C20.9647 17.2525 21.3005 17.5883 21.3005 18.0025C21.3005 18.4167 20.9647 18.7525 20.5505 18.7525H15.5254Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.646 12.1962C17.7166 12.6043 17.4431 12.9925 17.0349 13.0631L13.1283 13.7394C12.7201 13.8101 12.332 13.5365 12.2613 13.1283C12.1907 12.7202 12.4643 12.332 12.8724 12.2614L16.779 11.5851C17.1872 11.5145 17.5753 11.788 17.646 12.1962Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8047 9.66823C16.8753 10.0764 16.6016 10.4645 16.1935 10.5351L12.1278 11.2384C11.7196 11.309 11.3315 11.0353 11.2609 10.6272C11.1903 10.219 11.4639 9.83094 11.8721 9.76033L15.9378 9.05704C16.3459 8.98644 16.734 9.26007 16.8047 9.66823Z"
        // fill={fill}
      />
    </svg>
  );
};

export const TrackingPixelsIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-tracking-pixels"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.24987C15.865 2.18608 19.4346 4.31207 21.2193 7.74178L21.228 7.75887C21.3943 8.09952 21.5225 8.45749 21.6103 8.82628C21.7063 9.22923 21.4574 9.63365 21.0544 9.72959C20.6515 9.82552 20.2471 9.57664 20.1511 9.17369C20.0896 8.91529 20.0001 8.6644 19.8842 8.42544C18.3586 5.50172 15.3112 3.69113 12.0134 3.74986C12.0045 3.75002 11.9955 3.75002 11.9866 3.74986C8.68827 3.69113 5.64046 5.50231 4.11513 8.42686C3.62817 9.41933 3.62829 10.5814 4.11548 11.5738C5.48048 14.2052 8.10482 15.948 11.06 16.1852C11.4729 16.2184 11.7807 16.58 11.7476 16.9928C11.7145 17.4057 11.3529 17.7136 10.94 17.6804C7.46635 17.4016 4.38193 15.3515 2.77995 12.2568C2.77734 12.2517 2.7748 12.2467 2.77232 12.2416C2.07553 10.8276 2.07589 9.16991 2.77341 7.75614C2.77603 7.75083 2.77871 7.74556 2.78144 7.74033C4.56637 4.31148 8.13558 2.18609 12 2.24987Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 13.75C16.9812 13.75 15.75 14.9812 15.75 16.5C15.75 17.0675 16.0724 17.7496 16.6171 18.4611C17.1432 19.1483 17.7968 19.7601 18.2865 20.1759C18.412 20.2746 18.5888 20.2747 18.7143 20.176C19.2038 19.7601 19.857 19.1483 20.3829 18.4612C20.9276 17.7496 21.25 17.0675 21.25 16.5C21.25 14.9812 20.0188 13.75 18.5 13.75ZM18.5 12.25C16.1528 12.25 14.25 14.1528 14.25 16.5C14.25 17.571 14.8216 18.5833 15.4261 19.3729C16.0466 20.1835 16.7936 20.8768 17.324 21.3264L17.3358 21.3363C18.0143 21.8879 18.9867 21.8879 19.6651 21.3363L19.6773 21.3262C20.207 20.8767 20.9537 20.1834 21.5741 19.3729C22.1784 18.5833 22.75 17.571 22.75 16.5C22.75 14.1528 20.8472 12.25 18.5 12.25Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 8.74998C11.3096 8.74998 10.75 9.30963 10.75 9.99998C10.75 10.6903 11.3096 11.25 12 11.25C12.6904 11.25 13.25 10.6903 13.25 9.99998C13.25 9.30963 12.6904 8.74998 12 8.74998ZM9.25 9.99998C9.25 8.4812 10.4812 7.24998 12 7.24998C13.5188 7.24998 14.75 8.4812 14.75 9.99998C14.75 11.5188 13.5188 12.75 12 12.75C10.4812 12.75 9.25 11.5188 9.25 9.99998Z"
      />
      <path d="M19.5 16.5C19.5 17.0523 19.0523 17.5 18.5 17.5C17.9477 17.5 17.5 17.0523 17.5 16.5C17.5 15.9477 17.9477 15.5 18.5 15.5C19.0523 15.5 19.5 15.9477 19.5 16.5Z" />
    </svg>
  );
};

export const ManageUsersIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-users"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 15.75C4.21421 15.75 2.75 17.2142 2.75 19C2.75 19.4142 2.41421 19.75 2 19.75C1.58579 19.75 1.25 19.4142 1.25 19C1.25 16.3858 3.38579 14.25 6 14.25H10C12.6142 14.25 14.75 16.3858 14.75 19C14.75 19.4142 14.4142 19.75 14 19.75C13.5858 19.75 13.25 19.4142 13.25 19C13.25 17.2142 11.7858 15.75 10 15.75H6Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.97947 6.5402C8.82861 5.48136 7.01733 5.46818 6.04959 6.51036C5.04291 7.59448 5.08987 9.24845 6.1496 10.3897C7.11984 11.4346 8.83891 11.419 9.98966 10.3504C11.0556 9.36058 11.0879 7.6588 9.97947 6.5402ZM11.0068 5.4471C9.35665 3.91833 6.57863 3.73622 4.9504 5.48968C3.35709 7.20557 3.51013 9.7516 5.05041 11.4104C6.68016 13.1655 9.3611 12.9811 11.0103 11.4496C12.74 9.84346 12.7119 7.15491 11.0338 5.47312C11.0294 5.46872 11.025 5.46436 11.0205 5.46004C11.016 5.45566 11.0114 5.45135 11.0068 5.4471Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.25 14C15.25 13.5858 15.5858 13.25 16 13.25H19C21.1142 13.25 22.75 14.8858 22.75 17C22.75 17.4142 22.4142 17.75 22 17.75C21.5858 17.75 21.25 17.4142 21.25 17C21.25 15.7142 20.2858 14.75 19 14.75H16C15.5858 14.75 15.25 14.4142 15.25 14Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7836 7.24443C18.0522 6.60029 16.919 6.64163 16.3303 7.23035C16.321 7.23965 16.3115 7.2487 16.3017 7.25749C15.6827 7.81463 15.6639 8.92763 16.3575 9.6983C16.9146 10.3173 18.0276 10.3362 18.7983 9.64255C19.4466 9.05904 19.4926 7.96807 18.7836 7.24443ZM19.7966 6.13792C18.5319 5.00458 16.4912 4.96429 15.2837 6.15576C13.9189 7.40016 14.14 9.47676 15.2425 10.7017C16.4854 12.0827 18.5724 11.8639 19.8017 10.7575C21.1474 9.54636 21.1069 7.45155 19.8352 6.17459C19.829 6.16828 19.8227 6.16206 19.8162 6.15593C19.8097 6.14979 19.8032 6.14379 19.7966 6.13792Z"
      />
    </svg>
  );
};

export const PlannerIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-planner"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 3C12.75 2.58579 12.4142 2.25 12 2.25C11.5858 2.25 11.25 2.58579 11.25 3V4.28615C9.52346 4.45303 7.84222 5.19762 6.51992 6.51992C5.19762 7.84222 4.45303 9.52346 4.28615 11.25H3C2.58579 11.25 2.25 11.5858 2.25 12C2.25 12.4142 2.58579 12.75 3 12.75H4.28615C4.45304 14.4765 5.19763 16.1578 6.51992 17.4801C7.84222 18.8024 9.52346 19.547 11.25 19.7138V21C11.25 21.4142 11.5858 21.75 12 21.75C12.4142 21.75 12.75 21.4142 12.75 21V19.7138C14.4765 19.547 16.1578 18.8024 17.4801 17.4801C18.8024 16.1578 19.547 14.4765 19.7138 12.75H21C21.4142 12.75 21.75 12.4142 21.75 12C21.75 11.5858 21.4142 11.25 21 11.25H19.7138C19.547 9.52346 18.8024 7.84222 17.4801 6.51992C16.1578 5.19763 14.4765 4.45304 12.75 4.28615V3ZM18.2051 11.25C18.0439 9.90881 17.4487 8.60986 16.4194 7.58058C15.3901 6.55131 14.0912 5.95608 12.75 5.79489V7C12.75 7.41421 12.4142 7.75 12 7.75C11.5858 7.75 11.25 7.41421 11.25 7V5.79489C9.90881 5.95608 8.60986 6.55131 7.58058 7.58058C6.55131 8.60986 5.95608 9.90881 5.79489 11.25H7C7.41421 11.25 7.75 11.5858 7.75 12C7.75 12.4142 7.41421 12.75 7 12.75H5.79489C5.95608 14.0912 6.55131 15.3901 7.58058 16.4194C8.60986 17.4487 9.90881 18.0439 11.25 18.2051V17C11.25 16.5858 11.5858 16.25 12 16.25C12.4142 16.25 12.75 16.5858 12.75 17V18.2051C14.0912 18.0439 15.3901 17.4487 16.4194 16.4194C17.4487 15.3901 18.0439 14.0912 18.2051 12.75H17C16.5858 12.75 16.25 12.4142 16.25 12C16.25 11.5858 16.5858 11.25 17 11.25H18.2051Z"
      />
    </svg>
  );
};

export const OOHPlannerIcon: FC<SVGProps<number | string>> = () => (
  <svg
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 19.5C9.76225 19.5 9.53875 19.3875 9.39775 19.197C9.1465 18.8588 3.25 10.8577 3.25 6.75C3.25 3.0285 6.2785 0 10 0C13.7222 0 16.75 3.0285 16.75 6.75C16.75 10.8577 10.8535 18.8588 10.6022 19.197C10.4612 19.3875 10.2378 19.5 10 19.5ZM10 1.5C7.105 1.5 4.75 3.855 4.75 6.75C4.75 9.43125 8.11975 14.7878 10 17.466C11.8802 14.787 15.25 9.429 15.25 6.75C15.25 3.855 12.8942 1.5 10 1.5Z"
      fill="currentColor"
    />
    <path
      d="M10 9.75C8.3455 9.75 7 8.4045 7 6.75C7 5.0955 8.3455 3.75 10 3.75C11.6545 3.75 13 5.0955 13 6.75C13 8.4045 11.6545 9.75 10 9.75ZM10 5.25C9.17275 5.25 8.5 5.92275 8.5 6.75C8.5 7.57725 9.17275 8.25 10 8.25C10.8273 8.25 11.5 7.57725 11.5 6.75C11.5 5.92275 10.8273 5.25 10 5.25Z"
      fill="currentColor"
    />
    <path
      d="M10 23.9999C5.2735 23.9999 0.25 22.5359 0.25 19.8216C0.25 18.4754 1.5145 17.3099 3.8095 16.5389C4.2025 16.4091 4.62775 16.6184 4.759 17.0114C4.891 17.4036 4.6795 17.8296 4.28725 17.9616C2.4145 18.5894 1.75 19.3566 1.75 19.8216C1.75 20.9136 4.96375 22.4999 10 22.4999C15.0363 22.4999 18.25 20.9136 18.25 19.8216C18.25 19.3566 17.5847 18.5894 15.712 17.9609C15.3197 17.8281 15.1075 17.4036 15.2395 17.0106C15.3722 16.6184 15.7975 16.4076 16.1898 16.5381C18.4855 17.3099 19.75 18.4761 19.75 19.8216C19.75 22.5359 14.7265 23.9999 10 23.9999Z"
      fill="currentColor"
    />
  </svg>
);

export const DesignSystemIcon: FC<SVGProps<number | string>> = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.8125 25.9806C0.599625 25.9806 0.391625 25.8961 0.238063 25.7425C0.043875 25.5484 -0.039 25.268 0.017875 24.9991L1.46819 18.1676C1.57625 17.6598 1.82731 17.1975 2.19456 16.8302L18.4397 0.583477C19.2189 -0.194898 20.5733 -0.194086 21.3509 0.583477L25.3963 4.62891C26.1982 5.43166 26.1982 6.73735 25.3963 7.5401L9.15038 23.7868C8.78475 24.1533 8.32244 24.4044 7.81381 24.5132L0.980688 25.9635L0.8125 25.9806V25.9806ZM19.8957 1.6056C19.7795 1.6056 19.6706 1.6511 19.5886 1.73316L3.34262 17.9783C3.198 18.1229 3.09969 18.3041 3.05663 18.5048L1.86631 24.1127L7.475 22.9224C7.67406 22.8801 7.85606 22.781 7.99987 22.6364L24.2482 6.39204C24.4172 6.22304 24.4172 5.9476 24.2482 5.7786L20.2028 1.73316C20.1207 1.65029 20.0119 1.6056 19.8957 1.6056V1.6056ZM8.12419 23.5431C7.74475 23.5431 7.40513 23.2766 7.32875 22.8898C6.9095 20.7928 5.20813 19.1621 3.09481 18.833L2.96725 18.8127C2.52444 18.742 2.22219 18.3244 2.29369 17.8816C2.36437 17.438 2.78119 17.1333 3.22481 17.208L3.34831 17.2275C6.12869 17.6606 8.37037 19.8089 8.92206 22.5705C9.00981 23.0109 8.72462 23.4383 8.28506 23.5269L8.12419 23.5431V23.5431ZM4.75231 11.4783C4.54431 11.4783 4.33631 11.3987 4.17788 11.2402L0.611 7.67335C0.216937 7.2801 0 6.75604 0 6.19948C0 5.64291 0.216937 5.11885 0.611 4.72479L4.74419 0.591602C5.53231 -0.196523 6.90544 -0.196523 7.69356 0.591602L11.2604 4.15848C11.5781 4.47616 11.5781 4.98966 11.2604 5.30735C10.9428 5.62504 10.4292 5.62504 10.1116 5.30735L6.54469 1.74048C6.37081 1.5666 6.06694 1.5666 5.89306 1.74048L1.75987 5.87366C1.67294 5.9606 1.625 6.07598 1.625 6.19948C1.625 6.32298 1.67294 6.43835 1.75987 6.52529L5.32675 10.0922C5.64444 10.4099 5.64444 10.9234 5.32675 11.241C5.1675 11.3995 4.9595 11.4783 4.75231 11.4783V11.4783ZM19.7811 25.9806C19.2238 25.9806 18.7005 25.7637 18.3064 25.3688L14.7404 21.8027C14.4227 21.485 14.4227 20.9715 14.7404 20.6539C15.0581 20.3362 15.5716 20.3362 15.8892 20.6539L19.4561 24.2207C19.6308 24.3954 19.9331 24.3954 20.1077 24.2207L24.2409 20.0875C24.3271 20.0006 24.375 19.8844 24.375 19.7617C24.375 19.639 24.3271 19.5237 24.2409 19.4375L20.6733 15.8699C20.3556 15.5522 20.3556 15.0387 20.6733 14.721C20.9909 14.4033 21.5044 14.4033 21.8221 14.721L25.389 18.2879C25.7831 18.6811 26 19.2044 26 19.7617C26 20.3191 25.7831 20.8424 25.389 21.2364L21.2558 25.3696C20.8617 25.7637 20.3377 25.9806 19.7811 25.9806V25.9806ZM4.875 11.3556C4.667 11.3556 4.459 11.276 4.30056 11.1175C3.98288 10.7999 3.98288 10.2864 4.30056 9.96866L6.73806 7.53116C7.05575 7.21348 7.56925 7.21348 7.88694 7.53116C8.20462 7.84885 8.20462 8.36235 7.88694 8.68004L5.44944 11.1175C5.291 11.276 5.083 11.3556 4.875 11.3556V11.3556ZM15.4375 21.9181C15.2295 21.9181 15.0215 21.8385 14.8631 21.68C14.5454 21.3624 14.5454 20.8489 14.8631 20.5312L17.3006 18.0937C17.6182 17.776 18.1318 17.776 18.4494 18.0937C18.7671 18.4114 18.7671 18.9249 18.4494 19.2425L16.0119 21.68C15.8535 21.8385 15.6455 21.9181 15.4375 21.9181ZM2.4375 9.04079C2.2295 9.04079 2.0215 8.96116 1.86306 8.80273C1.54537 8.48504 1.54537 7.97154 1.86306 7.65385L4.30056 5.21635C4.61825 4.89866 5.13175 4.89866 5.44944 5.21635C5.76712 5.53404 5.76712 6.04754 5.44944 6.36523L3.01194 8.80273C2.8535 8.96198 2.6455 9.04079 2.4375 9.04079ZM17.875 24.3556C17.667 24.3556 17.459 24.276 17.3006 24.1175C16.9829 23.7999 16.9829 23.2863 17.3006 22.9687L19.7381 20.5312C20.0557 20.2135 20.5693 20.2135 20.8869 20.5312C21.2046 20.8489 21.2046 21.3624 20.8869 21.68L18.4494 24.1175C18.291 24.276 18.083 24.3556 17.875 24.3556ZM21.9375 9.7306C21.7295 9.7306 21.5215 9.65098 21.3631 9.49254L16.4881 4.61754C16.1704 4.29985 16.1704 3.78635 16.4881 3.46866C16.8057 3.15098 17.3193 3.15098 17.6369 3.46866L22.5119 8.34366C22.8296 8.66135 22.8296 9.17485 22.5119 9.49254C22.3535 9.65098 22.1455 9.7306 21.9375 9.7306Z"
      fill="currentColor"
    />
  </svg>
);

export const ManageWhitelistsIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="iconpPublisher-groups"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.24884 8.01606C8.24884 7.60184 8.58462 7.26606 8.99884 7.26606H15.0013C15.4156 7.26606 15.7513 7.60184 15.7513 8.01606C15.7513 8.43027 15.4156 8.76606 15.0013 8.76606H8.99884C8.58462 8.76606 8.24884 8.43027 8.24884 8.01606Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.24884 12C8.24884 11.5858 8.58462 11.25 8.99884 11.25H12.0001C12.4143 11.25 12.7501 11.5858 12.7501 12C12.7501 12.4142 12.4143 12.75 12.0001 12.75H8.99884C8.58462 12.75 8.24884 12.4142 8.24884 12Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.74696 3.9967C3.74696 3.58249 4.08275 3.2467 4.49696 3.2467H16.0018C17.521 3.2467 18.7526 4.47829 18.7526 5.99754V16.0017C18.7526 16.4159 18.4168 16.7517 18.0026 16.7517C17.5884 16.7517 17.2526 16.4159 17.2526 16.0017V5.99754C17.2526 5.30672 16.6926 4.7467 16.0018 4.7467H4.49696C4.08275 4.7467 3.74696 4.41092 3.74696 3.9967Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.24634 5.49733C2.24634 4.25434 3.25398 3.2467 4.49696 3.2467C5.73995 3.2467 6.74759 4.25434 6.74759 5.49733V18.5027C6.74759 18.9173 7.08365 19.2534 7.49821 19.2534C7.91277 19.2534 8.24884 18.9173 8.24884 18.5027V17.0021C8.24884 16.0354 9.03253 15.2517 9.99925 15.2517H20.0034C20.9702 15.2517 21.7538 16.0354 21.7538 17.0021V18.0025C21.7538 19.5218 20.5222 20.7534 19.003 20.7534H7.49821C6.25523 20.7534 5.24759 19.7457 5.24759 18.5027V9.74879H3.99675C3.03003 9.74879 2.24634 8.9651 2.24634 7.99837V5.49733ZM5.24759 8.24879V5.49733C5.24759 5.08277 4.91152 4.7467 4.49696 4.7467C4.0824 4.7467 3.74634 5.08277 3.74634 5.49733V7.99837C3.74634 8.13667 3.85845 8.24879 3.99675 8.24879H5.24759ZM9.62063 19.2534H19.003C19.6938 19.2534 20.2538 18.6934 20.2538 18.0025V17.0021C20.2538 16.8638 20.1417 16.7517 20.0034 16.7517H9.99925C9.86095 16.7517 9.74884 16.8638 9.74884 17.0021V18.5027C9.74884 18.766 9.70366 19.0186 9.62063 19.2534Z"
      />
    </svg>
  );
};

export const ManageCampaignsIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-campaigns"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.87668 13.0222C7.28525 12.9541 7.67168 13.2301 7.73979 13.6387L8.55579 18.5337C8.67362 19.2426 9.28651 19.762 10.005 19.762C10.9124 19.762 11.6031 18.9473 11.4542 18.0513L10.7602 13.8853C10.6921 13.4767 10.9682 13.0903 11.3768 13.0222C11.7853 12.9541 12.1717 13.2302 12.2398 13.6388L12.9338 17.8048C13.2348 19.6146 11.8396 21.262 10.005 21.262C8.55361 21.262 7.31453 20.2132 7.07621 18.7803L6.26021 13.8853C6.1921 13.4768 6.4681 13.0903 6.87668 13.0222Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.875 7.76201C4.42521 7.76201 3.25 8.93722 3.25 10.387C3.25 11.8368 4.42521 13.012 5.875 13.012H13.75C14.1642 13.012 14.5 13.3478 14.5 13.762C14.5 14.1762 14.1642 14.512 13.75 14.512H5.875C3.59679 14.512 1.75 12.6652 1.75 10.387C1.75 8.1088 3.59679 6.26201 5.875 6.26201H13.75C14.1642 6.26201 14.5 6.5978 14.5 7.01201C14.5 7.42622 14.1642 7.76201 13.75 7.76201H5.875Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1666 4.3023L14.166 7.63605C13.8214 7.86581 13.3557 7.77268 13.126 7.42804C12.8962 7.08339 12.9893 6.61774 13.334 6.38797L18.335 3.05397C19.5815 2.22407 21.25 3.11729 21.25 4.61501V16.16C21.25 17.6589 19.5809 18.5495 18.3354 17.7203L13.334 14.386C12.9893 14.1563 12.8962 13.6906 13.126 13.346C13.3557 13.0013 13.8214 12.9082 14.166 13.138L19.1666 16.4717C19.4171 16.6382 19.75 16.459 19.75 16.16V4.61501C19.75 4.31478 19.4161 4.13635 19.1666 4.3023Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.75 6.26001C14.1642 6.26001 14.5 6.5958 14.5 7.01001V13.76C14.5 14.1742 14.1642 14.51 13.75 14.51C13.3358 14.51 13 14.1742 13 13.76V7.01001C13 6.5958 13.3358 6.26001 13.75 6.26001Z"
      />
    </svg>
  );
};

export const ManageProductsIcon: FC<SVGProps<number | string>> = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M12.7887 26C12.2688 26 11.7796 25.7977 11.4116 25.4296L0.570375 14.5876C0.203125 14.2204 0 13.7312 0 13.2113C0 12.6912 0.203125 12.2021 0.570375 11.8341L11.8341 0.570375C12.2484 0.156 12.8156 -0.0479375 13.4046 0.00975L24.0744 0C24.5895 0 25.0729 0.200687 25.4369 0.564687C25.8009 0.928688 26 1.41294 25.9992 1.92725L25.9943 12.6409C26.0382 13.208 25.8342 13.7613 25.4304 14.1659L14.1668 25.4296C13.7987 25.7977 13.3096 26 12.7887 26ZM13.2519 1.62744C13.1194 1.62744 13.0422 1.66075 12.9829 1.71925L1.71925 12.9829C1.63719 13.065 1.625 13.1609 1.625 13.2113C1.625 13.2608 1.63719 13.3567 1.71925 13.4388L12.5604 24.2808C12.7246 24.4457 12.8513 24.4457 13.0163 24.2808L24.2799 13.0171C24.3482 12.9488 24.3823 12.8538 24.3726 12.7571C24.3701 12.7303 24.3685 12.7026 24.3685 12.675L24.3734 1.92562C24.3734 1.81675 24.3189 1.74606 24.2864 1.71356C24.2539 1.68025 24.1832 1.625 24.0744 1.625L13.325 1.62988C13.2982 1.62825 13.2738 1.62744 13.2519 1.62744Z"
        fill="currentColor"
      />
      <path
        d="M8.9375 14.625C8.7295 14.625 8.5215 14.5454 8.36306 14.387C8.04537 14.0693 8.04537 13.5558 8.36306 13.2381L14.0506 7.55058C14.3682 7.2329 14.8818 7.2329 15.1994 7.55058C15.5171 7.86827 15.5171 8.38177 15.1994 8.69946L9.51194 14.387C9.3535 14.5454 9.1455 14.625 8.9375 14.625Z"
        fill="currentColor"
      />
      <path
        d="M12.1875 17.875C11.9795 17.875 11.7715 17.7954 11.6131 17.637C11.2954 17.3193 11.2954 16.8058 11.6131 16.4881L17.3006 10.8006C17.6182 10.4829 18.1318 10.4829 18.4494 10.8006C18.7671 11.1183 18.7671 11.6318 18.4494 11.9495L12.7619 17.637C12.6035 17.7954 12.3955 17.875 12.1875 17.875Z"
        fill="currentColor"
      />
      <path
        d="M21.125 5.68748C20.9137 5.68748 20.7017 5.5981 20.5481 5.45185C20.4011 5.29748 20.3125 5.08623 20.3125 4.87498C20.3125 4.66373 20.4011 4.45248 20.5481 4.2981C20.8569 3.99748 21.4012 3.99748 21.7019 4.2981C21.8481 4.45248 21.9375 4.66373 21.9375 4.87498C21.9375 5.08623 21.8481 5.29748 21.7019 5.45185C21.5475 5.5981 21.3362 5.68748 21.125 5.68748Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PublisherManagerIcon: FC<CommonIconProps> = () => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 3C0.25 1.48079 1.48079 0.25 3 0.25H10.172C10.9011 0.25 11.6008 0.540176 12.1163 1.05567L14.9443 3.88367C15.4598 4.39916 15.75 5.09886 15.75 5.828V17C15.75 18.5192 14.5192 19.75 13 19.75H3C1.48079 19.75 0.25 18.5192 0.25 17V3ZM3 1.75C2.30921 1.75 1.75 2.30921 1.75 3V17C1.75 17.6908 2.30921 18.25 3 18.25H13C13.6908 18.25 14.25 17.6908 14.25 17V5.828C14.25 5.49714 14.1182 5.17884 13.8837 4.94433L11.0557 2.11633C10.8212 1.88182 10.5029 1.75 10.172 1.75H3Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0.25C10.4142 0.25 10.75 0.585786 10.75 1V5C10.75 5.13779 10.8622 5.25 11 5.25H15C15.4142 5.25 15.75 5.58579 15.75 6C15.75 6.41421 15.4142 6.75 15 6.75H11C10.0338 6.75 9.25 5.96621 9.25 5V1C9.25 0.585786 9.58579 0.25 10 0.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.96104 14.4321C4.12149 14.2716 4.32305 14.2111 4.49499 14.2111C4.66693 14.2111 4.86849 14.2716 5.02895 14.4321C5.12349 14.5267 5.18336 14.6355 5.2166 14.7441C5.2383 14.8142 5.24999 14.8888 5.24999 14.9661C5.24999 15.0433 5.2383 15.1179 5.2166 15.188C5.18336 15.2967 5.12349 15.4055 5.02895 15.5C4.86849 15.6605 4.66693 15.7211 4.49499 15.7211C4.32305 15.7211 4.12149 15.6605 3.96104 15.5C3.80058 15.3396 3.73999 15.138 3.73999 14.9661C3.73999 14.7941 3.80058 14.5926 3.96104 14.4321Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 8.995C3.25 8.58078 3.58579 8.245 4 8.245H12C12.4142 8.245 12.75 8.58078 12.75 8.995C12.75 9.40921 12.4142 9.745 12 9.745H4C3.58579 9.745 3.25 9.40921 3.25 8.995Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 11.995C3.25 11.5808 3.58579 11.245 4 11.245H12C12.4142 11.245 12.75 11.5808 12.75 11.995C12.75 12.4092 12.4142 12.745 12 12.745H4C3.58579 12.745 3.25 12.4092 3.25 11.995Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.961 14.466C11.1215 14.3056 11.3231 14.245 11.495 14.245C11.6669 14.245 11.8685 14.3056 12.0289 14.466C12.1235 14.5606 12.1834 14.6694 12.2166 14.778C12.2383 14.8482 12.25 14.9227 12.25 15C12.25 15.0773 12.2383 15.1518 12.2166 15.222C12.1834 15.3306 12.1235 15.4394 12.0289 15.534C11.8685 15.6944 11.6669 15.755 11.495 15.755C11.3231 15.755 11.1215 15.6944 10.961 15.534C10.8006 15.3735 10.74 15.1719 10.74 15C10.74 14.8281 10.8006 14.6265 10.961 14.466Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.46604 14.456C7.6265 14.2956 7.82806 14.235 8 14.235C8.17193 14.235 8.37349 14.2956 8.53395 14.456C8.6285 14.5506 8.68837 14.6594 8.7216 14.768C8.74331 14.8382 8.755 14.9127 8.755 14.99C8.755 15.0673 8.74331 15.1418 8.7216 15.212C8.68837 15.3206 8.6285 15.4294 8.53395 15.5239C8.37349 15.6844 8.17193 15.745 8 15.745C7.82806 15.745 7.6265 15.6844 7.46604 15.5239C7.30558 15.3635 7.245 15.1619 7.245 14.99C7.245 14.8181 7.30558 14.6165 7.46604 14.456Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CreativeLibraryIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-creative-library"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 3.75C6.30921 3.75 5.75 4.30921 5.75 5V16C5.75 16.6908 6.30921 17.25 7 17.25H20C20.6908 17.25 21.25 16.6908 21.25 16V5C21.25 4.30921 20.6908 3.75 20 3.75H7ZM4.25 5C4.25 3.48079 5.48079 2.25 7 2.25H20C21.5192 2.25 22.75 3.48079 22.75 5V16C22.75 17.5192 21.5192 18.75 20 18.75H7C5.48079 18.75 4.25 17.5192 4.25 16V5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 7.64899C2.41421 7.64899 2.75 7.98477 2.75 8.39899V19C2.75 19.6908 3.30921 20.25 4 20.25H15.996C16.4102 20.25 16.746 20.5858 16.746 21C16.746 21.4142 16.4102 21.75 15.996 21.75H4C2.48079 21.75 1.25 20.5192 1.25 19V8.39899C1.25 7.98477 1.58579 7.64899 2 7.64899Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8154 7.35159C10.4573 6.99348 9.87669 6.99348 9.51858 7.35159C9.16048 7.7097 9.16047 8.29031 9.51858 8.64842C9.87669 9.00653 10.4573 9.00653 10.8154 8.64842C11.1735 8.29031 11.1735 7.7097 10.8154 7.35159ZM11.8752 6.29007C10.9313 5.34703 9.40153 5.34732 8.45792 6.29093C7.51402 7.23482 7.51403 8.76518 8.45792 9.70908C9.40182 10.653 10.9322 10.653 11.8761 9.70908C12.82 8.76519 12.82 7.23483 11.8761 6.29093"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6225 10.8113C17.2262 10.0572 18.3281 9.9345 19.0827 10.5385L22.4686 13.2474C22.792 13.5062 22.8444 13.9781 22.5857 14.3016C22.3269 14.625 21.8549 14.6774 21.5315 14.4187L18.1455 11.7097C18.0381 11.6237 17.88 11.6409 17.7937 11.7485L15.2217 14.9635C14.6177 15.718 13.517 15.8401 12.762 15.2371L11.4626 14.1977C11.3562 14.1127 11.2017 14.1281 11.1143 14.233L7.57626 18.4801C7.31114 18.7983 6.83822 18.8414 6.51997 18.5763C6.20172 18.3111 6.15865 17.8382 6.42378 17.52L9.96174 13.273C9.96173 13.273 9.96175 13.273 9.96174 13.273C10.5723 12.54 11.6558 12.4314 12.3995 13.0263C12.3995 13.0263 12.3995 13.0263 12.3995 13.0263L13.698 14.065C13.698 14.0649 13.6981 14.065 13.698 14.065C13.8069 14.1518 13.9643 14.1338 14.0504 14.0265M14.0504 14.0265L16.6225 10.8113L14.0504 14.0265Z"
      />
    </svg>
  );
};

export const LinearMeasurementIcon: FC<SVGProps<number | string>> = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.1287 20.25H1.872C0.84 20.25 0 19.4107 0 18.3787V4.122C0 3.09 0.84 2.25 1.872 2.25H22.1287C23.1607 2.25 24 3.09 24 4.122V18.3787C24 19.4107 23.1607 20.25 22.1287 20.25ZM1.872 3.75C1.67025 3.75 1.5 3.92025 1.5 4.122V18.3787C1.5 18.5797 1.67025 18.75 1.872 18.75H22.1287C22.3297 18.75 22.5 18.5797 22.5 18.3787V4.122C22.5 3.92025 22.3297 3.75 22.1287 3.75H1.872Z"
      fill="currentColor"
    />
    <path
      d="M12 23.25C11.586 23.25 11.25 22.9147 11.25 22.5V19.5C11.25 19.0853 11.586 18.75 12 18.75C12.414 18.75 12.75 19.0853 12.75 19.5V22.5C12.75 22.9147 12.414 23.25 12 23.25Z"
      fill="currentColor"
    />
    <path
      d="M16.5 24H7.5C7.086 24 6.75 23.6647 6.75 23.25C6.75 22.8353 7.086 22.5 7.5 22.5H16.5C16.9147 22.5 17.25 22.8353 17.25 23.25C17.25 23.6647 16.9147 24 16.5 24Z"
      fill="currentColor"
    />
  </svg>
);

export const CustomReportingIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-custom-reporting"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path d="M5.99754 2.24628C4.47829 2.24628 3.2467 3.47787 3.2467 4.99711V19.0029C3.2467 20.5222 4.47829 21.7538 5.99754 21.7538H7.99837C8.41258 21.7538 8.74837 21.418 8.74837 21.0038C8.74837 20.5896 8.41258 20.2538 7.99837 20.2538H5.99754C5.30672 20.2538 4.7467 19.6938 4.7467 19.0029V4.99711C4.7467 4.92455 4.75288 4.85344 4.76474 4.78427C4.86578 4.19484 5.37928 3.74628 5.99754 3.74628H15.1734C15.5048 3.74628 15.823 3.87818 16.0576 4.11285L18.8869 6.94211C19.1216 7.17671 19.2534 7.4948 19.2534 7.82629V12C19.2534 12.4142 19.5892 12.75 20.0034 12.75C20.4176 12.75 20.7534 12.4142 20.7534 12V7.82629C20.7534 7.09659 20.4632 6.39696 19.9474 5.88129L17.1183 3.05219C16.6026 2.53641 15.9031 2.24628 15.1734 2.24628H5.99754Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9996 16.5022C10.5854 16.5022 10.2496 16.838 10.2496 17.2522V21.0038C10.2496 21.418 10.5854 21.7538 10.9996 21.7538H13.9991L14.0009 21.7538H17.0021L17.008 21.7538H20.0033C20.4175 21.7538 20.7533 21.418 20.7533 21.0038V15.2514C20.7533 14.8372 20.4175 14.5014 20.0033 14.5014H17.7521V13.0005C17.7521 12.5862 17.4163 12.2505 17.0021 12.2505H14.0009C13.5866 12.2505 13.2509 12.5862 13.2509 13.0005V16.5022H10.9996ZM17.7521 20.2538V16.0014H19.2533V20.2538H17.7521ZM16.2521 15.2446V13.7505H14.7509V17.2455L14.7509 17.2522V20.2538H16.2521V15.2514L16.2521 15.2446ZM13.2509 20.2538V18.0022H11.7496V20.2538H13.2509Z"
      />
      <path d="M7.24841 7.99838C7.24841 7.58417 7.5842 7.24838 7.99841 7.24838H15.0013C15.4155 7.24838 15.7513 7.58417 15.7513 7.99838C15.7513 8.4126 15.4155 8.74838 15.0013 8.74838H7.99841C7.5842 8.74838 7.24841 8.4126 7.24841 7.99838Z" />
      <path d="M7.99841 10.7498C7.5842 10.7498 7.24841 11.0856 7.24841 11.4998C7.24841 11.9141 7.5842 12.2498 7.99841 12.2498H10.4995C10.9137 12.2498 11.2495 11.9141 11.2495 11.4998C11.2495 11.0856 10.9137 10.7498 10.4995 10.7498H7.99841Z" />
    </svg>
  );
};

export const AudiencesIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-audiences"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2273 9.80382C19.7249 9.30668 18.9102 9.30668 18.4077 9.80382C17.9052 10.301 17.9052 11.107 18.4077 11.6041C18.9102 12.1012 19.7249 12.1013 20.2273 11.6041C20.7298 11.107 20.7298 10.301 20.2273 9.80382ZM21.2985 8.7423C20.2039 7.66024 18.4299 7.66052 17.3356 8.74316C16.2411 9.82609 16.2411 11.5818 17.3356 12.6648C18.4302 13.7477 20.2048 13.7477 21.2994 12.6648C22.394 11.5818 22.394 9.82609 21.2994 8.74316C21.2991 8.74288 21.2988 8.74259 21.2985 8.7423Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5666 6.19269C12.6331 5.2691 11.1195 5.2691 10.186 6.19269C9.2525 7.11629 9.2525 8.61372 10.186 9.53731C11.1195 10.4609 12.6331 10.4609 13.5666 9.53731C14.5001 8.61371 14.5001 7.11628 13.5666 6.19269ZM14.6383 5.13165C13.1126 3.62266 10.6394 3.62278 9.11395 5.13203C7.58836 6.64141 7.58836 9.0886 9.11395 10.598C10.6396 12.1073 13.113 12.1073 14.6386 10.598C16.1642 9.08859 16.1639 6.64103 14.6383 5.13165C14.6384 5.13178 14.6381 5.13153 14.6383 5.13165Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.34497 9.80382C4.84249 9.30668 4.02781 9.30668 3.52533 9.80382C3.02285 10.301 3.02285 11.107 3.52533 11.6041C4.02781 12.1012 4.84249 12.1013 5.34497 11.6041C5.84745 11.107 5.84745 10.301 5.34497 9.80382ZM6.41616 8.7423C5.32153 7.66024 3.54754 7.66052 2.45327 8.74316C1.35871 9.82609 1.35871 11.5818 2.45327 12.6648C3.54783 13.7477 5.32247 13.7477 6.41703 12.6648C7.51159 11.5818 7.51159 9.82609 6.41703 8.74316C6.41674 8.74288 6.41645 8.74259 6.41616 8.7423Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8999 15.154C18.8999 14.7398 19.2393 14.404 19.658 14.404H20.4676C22.2821 14.404 23.7526 15.8588 23.7526 17.654V18.75C23.7526 19.1642 23.4132 19.5 22.9945 19.5C22.5758 19.5 22.2364 19.1642 22.2364 18.75V17.654C22.2364 16.6872 21.4448 15.904 20.4676 15.904H19.658C19.2393 15.904 18.8999 15.5682 18.8999 15.154Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.28493 15.904C2.30775 15.904 1.51612 16.6872 1.51612 17.654V18.75C1.51612 19.1642 1.17673 19.5 0.758061 19.5C0.339395 19.5 0 19.1642 0 18.75V17.654C0 15.8588 1.47042 14.404 3.28493 14.404H4.09454C4.51321 14.404 4.8526 14.7398 4.8526 15.154C4.8526 15.5682 4.51321 15.904 4.09454 15.904H3.28493Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.72074 17.149C5.72074 14.8018 7.64398 12.899 10.0164 12.899H13.735C16.1074 12.899 18.0306 14.8018 18.0306 17.149V18.75C18.0306 19.1642 17.6912 19.5 17.2726 19.5C16.8539 19.5 16.5145 19.1642 16.5145 18.75V17.149C16.5145 15.6302 15.2701 14.399 13.735 14.399H10.0164C8.48131 14.399 7.23687 15.6302 7.23687 17.149V18.75C7.23687 19.1642 6.89747 19.5 6.47881 19.5C6.06014 19.5 5.72074 19.1642 5.72074 18.75V17.149Z"
      />
    </svg>
  );
};

export const AdvancedExportsIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-advanced-exports"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25 5C4.25 3.48079 5.48079 2.25 7 2.25H14.172C14.9011 2.25 15.6008 2.54018 16.1163 3.05567L18.9443 5.88367C19.4598 6.39916 19.75 7.09886 19.75 7.828V19C19.75 20.5192 18.5192 21.75 17 21.75H7C5.48079 21.75 4.25 20.5192 4.25 19V5ZM7 3.75C6.30921 3.75 5.75 4.30921 5.75 5V19C5.75 19.6908 6.30921 20.25 7 20.25H17C17.6908 20.25 18.25 19.6908 18.25 19V7.828C18.25 7.49714 18.1182 7.17884 17.8837 6.94433L15.0557 4.11633C14.8212 3.88182 14.5029 3.75 14.172 3.75H7Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 2.25C14.4142 2.25 14.75 2.58579 14.75 3V7C14.75 7.13779 14.8622 7.25 15 7.25H19C19.4142 7.25 19.75 7.58579 19.75 8C19.75 8.41421 19.4142 8.75 19 8.75H15C14.0338 8.75 13.25 7.96621 13.25 7V3C13.25 2.58579 13.5858 2.25 14 2.25Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9658 12.2462C12.2148 11.4953 10.9972 11.4953 10.2462 12.2462C9.49526 12.9972 9.49526 14.2148 10.2462 14.9658C10.9972 15.7167 12.2148 15.7167 12.9658 14.9658C13.7167 14.2148 13.7167 12.9972 12.9658 12.2462ZM14.0264 11.1856C12.6897 9.84881 10.5223 9.84881 9.18558 11.1856C7.84882 12.5223 7.84882 14.6897 9.18558 16.0264C10.5223 17.3632 12.6897 17.3632 14.0264 16.0264C15.3632 14.6897 15.3632 12.5223 14.0264 11.1856Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9697 14.9697C13.2626 14.6768 13.7374 14.6768 14.0303 14.9697L15.5303 16.4697C15.8232 16.7626 15.8232 17.2374 15.5303 17.5303C15.2374 17.8232 14.7626 17.8232 14.4697 17.5303L12.9697 16.0303C12.6768 15.7374 12.6768 15.2626 12.9697 14.9697Z"
      />
    </svg>
  );
};

export const FootTrafficAttributionIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-foot-traffic-attribution"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.85958 14.0891C9.91366 14.4998 9.62459 14.8765 9.21392 14.9306C7.49238 15.1573 6.0579 15.5819 5.07758 16.1036C4.04382 16.6537 3.75 17.1733 3.75 17.5C3.75 17.7025 3.85256 17.9772 4.21485 18.3103C4.57778 18.644 5.14435 18.979 5.90772 19.2759C7.42968 19.8678 9.58331 20.25 12 20.25C14.4167 20.25 16.5703 19.8678 18.0923 19.2759C18.8556 18.979 19.4222 18.644 19.7852 18.3103C20.1474 17.9772 20.25 17.7025 20.25 17.5C20.25 17.1733 19.9562 16.6537 18.9224 16.1036C17.9421 15.5819 16.5076 15.1573 14.7861 14.9306C14.3754 14.8765 14.0863 14.4998 14.1404 14.0891C14.1945 13.6784 14.5712 13.3893 14.9819 13.4434C16.8144 13.6847 18.4379 14.1466 19.6271 14.7794C20.7628 15.3838 21.75 16.2867 21.75 17.5C21.75 18.264 21.3489 18.9101 20.8004 19.4144C20.2526 19.9182 19.5012 20.3374 18.636 20.6739C16.9007 21.3487 14.5543 21.75 12 21.75C9.44569 21.75 7.09932 21.3487 5.36403 20.6739C4.49877 20.3374 3.74741 19.9182 3.19956 19.4144C2.65106 18.9101 2.25 18.264 2.25 17.5C2.25 16.2867 3.23718 15.3838 4.37292 14.7794C5.5621 14.1466 7.18562 13.6847 9.01808 13.4434C9.42875 13.3893 9.8055 13.6784 9.85958 14.0891Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 7.833C5.25 4.17803 8.29182 1.25 12 1.25C15.7082 1.25 18.75 4.17803 18.75 7.833C18.75 9.09267 18.3204 10.3358 17.7256 11.4615C17.1284 12.5917 16.341 13.6477 15.5687 14.546C14.7947 15.4465 14.0228 16.2034 13.4454 16.7348C13.1561 17.0009 12.9144 17.2117 12.7438 17.3568C12.6585 17.4294 12.5909 17.4856 12.544 17.5242C12.5205 17.5435 12.5022 17.5584 12.4894 17.5688L12.4745 17.5809L12.4688 17.5854C12.4687 17.5855 12.468 17.586 12 17C11.532 17.586 11.5318 17.5859 11.5316 17.5858L11.5255 17.5809L11.5106 17.5688C11.4978 17.5584 11.4795 17.5435 11.456 17.5242C11.4091 17.4856 11.3415 17.4294 11.2562 17.3568C11.0856 17.2117 10.8439 17.0009 10.5546 16.7348C9.97716 16.2034 9.20533 15.4465 8.43127 14.546C7.65903 13.6477 6.87165 12.5917 6.27439 11.4615C5.67956 10.3358 5.25 9.09267 5.25 7.833ZM12 17L11.5316 17.5858C11.8054 17.8044 12.1943 17.8047 12.468 17.586L12 17ZM12 16.0171C12.124 15.9084 12.2688 15.779 12.4296 15.631C12.9772 15.1272 13.7053 14.4127 14.4313 13.5682C15.159 12.7216 15.8716 11.7593 16.3994 10.7606C16.9296 9.75733 17.25 8.76083 17.25 7.833C17.25 5.04597 14.9198 2.75 12 2.75C9.08018 2.75 6.75 5.04597 6.75 7.833C6.75 8.76083 7.07044 9.75733 7.60061 10.7606C8.12835 11.7593 8.84097 12.7216 9.56873 13.5682C10.2947 14.4127 11.0228 15.1272 11.5704 15.631C11.7312 15.779 11.876 15.9084 12 16.0171Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8839 7.11612C12.3957 6.62796 11.6043 6.62796 11.1161 7.11612C10.6279 7.60428 10.6279 8.39573 11.1161 8.88389C11.6043 9.37205 12.3957 9.37205 12.8839 8.88389C13.372 8.39573 13.372 7.60428 12.8839 7.11612ZM13.9437 6.0546C12.8697 4.98152 11.1291 4.9818 10.0554 6.05546C8.9815 7.1294 8.9815 8.87061 10.0554 9.94455C11.1294 11.0185 12.8706 11.0185 13.9445 9.94455C15.0185 8.87061 15.0185 7.1294 13.9445 6.05546C13.9442 6.05517 13.944 6.05489 13.9437 6.0546Z"
      />
    </svg>
  );
};

export const ConversionDashboardIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-conversion-dashboard"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0.75C1.03379 0.75 0.25 1.53379 0.25 2.5V5.032C0.25 5.55076 0.481021 6.0438 0.879879 6.37618L7.25 11.6843V17.691C7.25 18.6211 8.22827 19.2239 9.05841 18.8088L11.782 17.447C12.3755 17.151 12.75 16.545 12.75 15.882V11.6843L19.1201 6.37617C19.5187 6.04404 19.75 5.55217 19.75 5.032V2.5C19.75 1.53379 18.9662 0.75 18 0.75H2ZM1.75 2.5C1.75 2.36221 1.86221 2.25 2 2.25H18C18.1378 2.25 18.25 2.36221 18.25 2.5V4.75H1.75V2.5ZM3.07161 6.25L8.48012 10.7568C8.65113 10.8993 8.75 11.1104 8.75 11.333V17.286L11.1116 16.1052C11.1958 16.0632 11.25 15.9769 11.25 15.882V11.333C11.25 11.1104 11.3489 10.8993 11.5199 10.7568L16.9284 6.25H3.07161Z"
      />
    </svg>
  );
};

export const ManageAdvertisersIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-advertisers"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.21989 10.14C4.63411 10.14 4.96989 10.4757 4.96989 10.89V20.89C4.96989 21.3042 4.63411 21.64 4.21989 21.64C3.80568 21.64 3.46989 21.3042 3.46989 20.89V10.89C3.46989 10.4757 3.80568 10.14 4.21989 10.14Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7799 10.14C20.1941 10.14 20.5299 10.4757 20.5299 10.89V20.89C20.5299 21.3042 20.1941 21.64 19.7799 21.64C19.3657 21.64 19.0299 21.3042 19.0299 20.89V10.89C19.0299 10.4757 19.3657 10.14 19.7799 10.14Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.02789 16.445C9.02789 14.8037 10.3587 13.473 11.9999 13.473C13.6411 13.473 14.9719 14.8037 14.9719 16.445V20.889C14.9719 21.3032 14.6361 21.639 14.2219 21.639C13.8077 21.639 13.4719 21.3032 13.4719 20.889V16.445C13.4719 15.6322 12.8127 14.973 11.9999 14.973C11.1871 14.973 10.5279 15.6322 10.5279 16.445V20.889C10.5279 21.3032 10.1921 21.639 9.77789 21.639C9.36368 21.639 9.02789 21.3032 9.02789 20.889V16.445Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.24989 20.89C1.24989 20.4757 1.58568 20.14 1.99989 20.14H21.9999C22.4141 20.14 22.7499 20.4757 22.7499 20.89C22.7499 21.3042 22.4141 21.64 21.9999 21.64H1.99989C1.58568 21.64 1.24989 21.3042 1.24989 20.89Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.06189 3.86096C5.42615 3.86096 4.8716 4.20541 4.61562 4.70953L2.9006 8.08656C2.44749 8.97863 3.09642 10.1288 4.30361 10.139C5.42893 10.1378 6.11766 9.39185 6.11989 8.72489V8.67796C6.11989 8.26375 6.45568 7.92796 6.86989 7.92796C7.28411 7.92796 7.61989 8.26375 7.61989 8.67796C7.61989 9.38382 8.3244 10.139 9.43589 10.139C10.5474 10.139 11.2519 9.38382 11.2519 8.67796C11.2519 8.26375 11.5877 7.92796 12.0019 7.92796C12.4161 7.92796 12.7519 8.26375 12.7519 8.67796C12.7519 9.38382 13.4564 10.139 14.5679 10.139C15.6794 10.139 16.3839 9.38382 16.3839 8.67796C16.3839 8.26375 16.7197 7.92796 17.1339 7.92796C17.5481 7.92796 17.8839 8.26375 17.8839 8.67796V8.72596C17.8839 9.39113 18.5707 10.1378 19.6972 10.139C20.9043 10.1288 21.5533 8.97877 21.1003 8.08672C21.1002 8.08668 21.1003 8.08676 21.1003 8.08672L19.3843 4.70972C19.1283 4.2056 18.5736 3.86096 17.9379 3.86096H6.06189ZM17.125 10.5681C16.4983 11.2373 15.5542 11.639 14.5679 11.639C13.5769 11.639 12.6286 11.2335 12.0019 10.5586C11.3752 11.2335 10.4269 11.639 9.43589 11.639C8.44892 11.639 7.5043 11.2368 6.87753 10.5668C6.24769 11.2389 5.29087 11.639 4.30089 11.639H4.29559C2.10846 11.6235 0.544668 9.41265 1.56318 7.40736M1.56318 7.40736L3.27817 4.03039C3.27816 4.0304 3.27817 4.03038 3.27817 4.03039C3.80419 2.99453 4.89365 2.36096 6.06189 2.36096H17.9379C19.1061 2.36096 20.1955 2.99444 20.7215 4.0302C20.7215 4.03014 20.7216 4.03027 20.7215 4.0302L22.4375 7.4072C23.4561 9.4125 21.8923 11.6235 19.7052 11.6389L19.6999 11.639C18.7111 11.639 17.7546 11.2396 17.125 10.5681"
      />
    </svg>
  );
};

export const ManageAgencyIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-agencies"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25006 15.1901C8.25006 14.7758 8.58585 14.4401 9.00006 14.4401H15.0001C15.4143 14.4401 15.7501 14.7758 15.7501 15.1901C15.7501 15.6043 15.4143 15.9401 15.0001 15.9401H9.00006C8.58585 15.9401 8.25006 15.6043 8.25006 15.1901Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2501 10.0001C17.2501 6.89168 14.5495 4.41388 11.3625 4.78795C9.07413 5.05598 7.17009 6.88121 6.81616 9.15328M11.1878 3.29815C15.2767 2.81833 18.7501 6.00449 18.7501 10.0001C18.7501 12.28 17.6163 14.2907 15.8899 15.5106C15.781 15.5875 15.7501 15.6751 15.7501 15.7331V18.5001C15.7501 20.2953 14.2953 21.7501 12.5001 21.7501H11.5001C9.70485 21.7501 8.25006 20.2953 8.25006 18.5001V15.7371C8.25006 15.6753 8.2174 15.586 8.10823 15.5086C6.11198 14.0979 4.91293 11.6309 5.33396 8.92284C5.7921 5.98105 8.23431 3.64418 11.1878 3.29815ZM6.81616 9.15328C6.48727 11.2691 7.41819 13.1842 8.97388 14.2836C9.41842 14.5981 9.75006 15.1169 9.75006 15.7371V18.5001C9.75006 19.4668 10.5333 20.2501 11.5001 20.2501H12.5001C13.4668 20.2501 14.2501 19.4668 14.2501 18.5001V15.7331C14.2501 15.115 14.5811 14.5986 15.0243 14.2855C16.3718 13.3334 17.2501 11.7701 17.2501 10.0001"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7204 3.27973C22.0133 3.57262 22.0133 4.0475 21.7204 4.34039L20.5304 5.53039C20.2375 5.82328 19.7626 5.82328 19.4697 5.53039C19.1768 5.2375 19.1768 4.76262 19.4697 4.46973L20.6597 3.27973C20.9526 2.98684 21.4275 2.98684 21.7204 3.27973Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.53039 14.4697C4.82328 14.7626 4.82328 15.2375 4.53039 15.5304L3.34039 16.7204C3.0475 17.0133 2.57262 17.0133 2.27973 16.7204C1.98684 16.4275 1.98684 15.9526 2.27973 15.6597L3.46973 14.4697C3.76262 14.1768 4.2375 14.1768 4.53039 14.4697Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.27973 2.27973C3.57262 1.98684 4.0475 1.98684 4.34039 2.27973L5.53039 3.46973C5.82328 3.76262 5.82328 4.2375 5.53039 4.53039C5.2375 4.82328 4.76262 4.82328 4.46973 4.53039L3.27973 3.34039C2.98684 3.0475 2.98684 2.57262 3.27973 2.27973Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4697 14.4697C19.7626 14.1768 20.2375 14.1768 20.5304 14.4697L21.7204 15.6597C22.0133 15.9526 22.0133 16.4275 21.7204 16.7204C21.4275 17.0133 20.9526 17.0133 20.6597 16.7204L19.4697 15.5304C19.1768 15.2375 19.1768 14.7626 19.4697 14.4697Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2501 10.0001C20.2501 9.58584 20.5858 9.25006 21.0001 9.25006H22.6901C23.1043 9.25006 23.4401 9.58584 23.4401 10.0001C23.4401 10.4143 23.1043 10.7501 22.6901 10.7501H21.0001C20.5858 10.7501 20.2501 10.4143 20.2501 10.0001Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.560059 10.0001C0.560059 9.58584 0.895845 9.25006 1.31006 9.25006H3.00006C3.41427 9.25006 3.75006 9.58584 3.75006 10.0001C3.75006 10.4143 3.41427 10.7501 3.00006 10.7501H1.31006C0.895845 10.7501 0.560059 10.4143 0.560059 10.0001Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25006 18.0001C8.25006 17.5858 8.58585 17.2501 9.00006 17.2501H14.8701C15.2843 17.2501 15.6201 17.5858 15.6201 18.0001C15.6201 18.4143 15.2843 18.7501 14.8701 18.7501H9.00006C8.58585 18.7501 8.25006 18.4143 8.25006 18.0001Z"
      />
    </svg>
  );
};

export const ManageStationIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-stations"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8362 3.46631C18.1291 3.17342 18.604 3.17342 18.8969 3.46631C22.7059 7.27539 22.7059 13.4511 18.8969 17.2602C18.604 17.5531 18.1291 17.5531 17.8362 17.2602C17.5433 16.9673 17.5433 16.4924 17.8362 16.1995C21.0595 12.9762 21.0595 7.75026 17.8362 4.52697C17.5433 4.23408 17.5433 3.75921 17.8362 3.46631Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.16356 3.46631C6.45645 3.75921 6.45645 4.23408 6.16356 4.52697C2.94027 7.75026 2.94027 12.9762 6.16356 16.1995C6.45645 16.4924 6.45645 16.9673 6.16356 17.2602C5.87067 17.5531 5.39579 17.5531 5.1029 17.2602C1.29383 13.4511 1.29383 7.27539 5.1029 3.46631C5.39579 3.17342 5.87067 3.17342 6.16356 3.46631Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.971 6.33151C15.2639 6.03861 15.7388 6.03861 16.0317 6.33151C17.101 7.4008 17.7017 8.85108 17.7017 10.3633C17.7017 11.8755 17.101 13.3258 16.0317 14.3951C15.7388 14.688 15.2639 14.688 14.971 14.3951C14.6781 14.1022 14.6781 13.6273 14.971 13.3344C15.759 12.5464 16.2017 11.4777 16.2017 10.3633C16.2017 9.24891 15.759 8.18016 14.971 7.39217C14.6781 7.09927 14.6781 6.6244 14.971 6.33151Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.02875 6.33151C9.32165 6.6244 9.32165 7.09927 9.02875 7.39217C8.24076 8.18016 7.79807 9.24891 7.79807 10.3633C7.79807 11.4777 8.24076 12.5464 9.02875 13.3344C9.32165 13.6273 9.32165 14.1022 9.02875 14.3951C8.73586 14.688 8.26099 14.688 7.96809 14.3951C6.89879 13.3258 6.29807 11.8755 6.29807 10.3633C6.29807 8.85108 6.89879 7.4008 7.96809 6.33151C8.26099 6.03861 8.73586 6.03861 9.02875 6.33151Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9999 9.61263C11.5853 9.61263 11.2493 9.9487 11.2493 10.3633C11.2493 10.7778 11.5853 11.1139 11.9999 11.1139C12.4144 11.1139 12.7505 10.7778 12.7505 10.3633C12.7505 9.9487 12.4144 9.61263 11.9999 9.61263ZM9.74926 10.3633C9.74926 9.12027 10.7569 8.11263 11.9999 8.11263C13.2429 8.11263 14.2505 9.12027 14.2505 10.3633C14.2505 11.6062 13.2429 12.6139 11.9999 12.6139C10.7569 12.6139 9.74926 11.6062 9.74926 10.3633Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9999 11.1139C12.4141 11.1139 12.7499 11.4497 12.7499 11.8639V20.0033C12.7499 20.4175 12.4141 20.7533 11.9999 20.7533C11.5857 20.7533 11.2499 20.4175 11.2499 20.0033V11.8639C11.2499 11.4497 11.5857 11.1139 11.9999 11.1139Z"
      />
    </svg>
  );
};

export const InternalToolsIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-internal-tools"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3611 4.74249C17.6342 4.43107 18.1081 4.40001 18.4195 4.67312C20.0022 6.06105 21.1375 7.9513 21.5628 10.1047C21.643 10.5111 21.3787 10.9055 20.9723 10.9858C20.5659 11.066 20.1715 10.8017 20.0912 10.3953C19.7325 8.5787 18.7738 6.97895 17.4305 5.80088C17.1191 5.52777 17.088 5.05392 17.3611 4.74249Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.02769 13.0142C3.43406 12.934 3.82853 13.1983 3.90878 13.6047C4.26753 15.4213 5.22616 17.0211 6.5695 18.1991C6.88092 18.4722 6.91199 18.9461 6.63888 19.2575C6.36577 19.5689 5.89191 19.6 5.58049 19.3269C3.99783 17.9389 2.86246 16.0487 2.4372 13.8953C2.35695 13.4889 2.62132 13.0945 3.02769 13.0142Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.39406 20.2732C8.52763 19.8811 8.95375 19.6715 9.34584 19.8051C10.1827 20.0901 11.0731 20.25 12 20.25C12.9269 20.25 13.8173 20.0901 14.6541 19.8051C15.0462 19.6715 15.4724 19.8811 15.6059 20.2732C15.7395 20.6652 15.5299 21.0914 15.1378 21.2249C14.1547 21.5599 13.1011 21.75 12 21.75C10.8989 21.75 9.84531 21.5599 8.86215 21.2249C8.47006 21.0914 8.26049 20.6652 8.39406 20.2732Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.86215 2.77506C9.84531 2.44014 10.8989 2.25 12 2.25C13.1011 2.25 14.1547 2.44014 15.1378 2.77506C15.5299 2.90863 15.7395 3.33476 15.6059 3.72685C15.4724 4.11893 15.0462 4.32851 14.6541 4.19494C13.8173 3.90986 12.9269 3.75 12 3.75C11.0731 3.75 10.1827 3.90986 9.34584 4.19494C8.95375 4.32851 8.52763 4.11893 8.39406 3.72685C8.26049 3.33476 8.47006 2.90863 8.86215 2.77506Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9723 13.0142C21.3787 13.0945 21.643 13.4889 21.5628 13.8953C21.1375 16.0487 20.0022 17.9389 18.4195 19.3269C18.1081 19.6 17.6342 19.5689 17.3611 19.2575C17.088 18.9461 17.1191 18.4722 17.4305 18.1991C18.7738 17.0211 19.7325 15.4213 20.0912 13.6047C20.1715 13.1983 20.5659 12.934 20.9723 13.0142Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.63885 4.74247C6.91198 5.05388 6.88094 5.52774 6.56953 5.80086C5.225 6.98008 4.26659 8.57881 3.90885 10.3949C3.8288 10.8014 3.43445 11.0659 3.02805 10.9859C2.62164 10.9058 2.35708 10.5115 2.43713 10.1051C2.8614 7.95119 3.99699 6.06192 5.58046 4.67314C5.89187 4.40002 6.36573 4.43106 6.63885 4.74247Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 8.5C11.4842 8.5 11.066 8.91821 11.066 9.434V10.75C11.066 11.1642 10.7302 11.5 10.316 11.5C9.90178 11.5 9.56599 11.1642 9.56599 10.75V9.434C9.56599 8.08979 10.6558 7 12 7C13.3442 7 14.434 8.08979 14.434 9.434V10.75C14.434 11.1642 14.0982 11.5 13.684 11.5C13.2698 11.5 12.934 11.1642 12.934 10.75V9.434C12.934 8.91821 12.5158 8.5 12 8.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99999 11.5C9.86221 11.5 9.74999 11.6122 9.74999 11.75V14.75C9.74999 14.8878 9.86221 15 9.99999 15H14C14.1378 15 14.25 14.8878 14.25 14.75V11.75C14.25 11.6122 14.1378 11.5 14 11.5H9.99999ZM8.24999 11.75C8.24999 10.7838 9.03378 10 9.99999 10H14C14.9662 10 15.75 10.7838 15.75 11.75V14.75C15.75 15.7162 14.9662 16.5 14 16.5H9.99999C9.03378 16.5 8.24999 15.7162 8.24999 14.75V11.75Z"
      />
    </svg>
  );
};

export const SpendDashboardIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99792 3.74625C6.3071 3.74625 5.74708 4.30627 5.74708 4.99708V8.99875C5.74708 9.41296 5.4113 9.74875 4.99708 9.74875C4.58287 9.74875 4.24708 9.41296 4.24708 8.99875V4.99708C4.24708 3.47784 5.47867 2.24625 6.99792 2.24625H19.0029C20.5222 2.24625 21.7537 3.47784 21.7537 4.99708V18.0025C21.7537 19.5217 20.5222 20.7533 19.0029 20.7533H11C10.5858 20.7533 10.25 20.4175 10.25 20.0033C10.25 19.5891 10.5858 19.2533 11 19.2533H19.0029C19.6937 19.2533 20.2537 18.6933 20.2537 18.0025V4.99708C20.2537 4.30627 19.6937 3.74625 19.0029 3.74625H6.99792ZM14.2513 6.99792C14.2513 6.5837 14.587 6.24792 15.0013 6.24792H17.0021C17.4163 6.24792 17.7521 6.5837 17.7521 6.99792V8.99875C17.7521 9.41296 17.4163 9.74875 17.0021 9.74875C16.5879 9.74875 16.2521 9.41296 16.2521 8.99875V8.80858L14.5312 10.5295C14.2689 10.7917 13.8544 10.8229 13.5559 10.6029L11.36 8.98472L10.5295 9.8152C10.2366 10.1081 9.76173 10.1081 9.46884 9.8152C9.17594 9.52231 9.17594 9.04743 9.46884 8.75454L10.7554 7.468C11.0176 7.20578 11.4321 7.17457 11.7306 7.39456L13.9266 9.01278L15.1914 7.74792H15.0013C14.587 7.74792 14.2513 7.41213 14.2513 6.99792ZM6.5 10.3393C6.91422 10.3393 7.25 10.6751 7.25 11.0893V11.5909C8.15385 11.6348 8.88386 12.1498 9.30642 12.8385C9.52303 13.1916 9.41241 13.6534 9.05935 13.87C8.70628 14.0866 8.24447 13.976 8.02787 13.6229C7.82128 13.2862 7.49677 13.0879 7.12429 13.0879H6.54671C6.53126 13.0888 6.51569 13.0893 6.5 13.0893C6.48432 13.0893 6.46875 13.0888 6.4533 13.0879H5.75429C5.19953 13.0879 4.75 13.5368 4.75 14.0921C4.75 14.5535 5.06574 14.957 5.51142 15.0691L7.85521 15.6579C8.96696 15.9389 9.75 16.9389 9.75 18.0893C9.75 19.4717 8.63033 20.5936 7.24571 20.5936H5.87571C4.91217 20.5936 4.13277 20.0588 3.69168 19.3379C3.4755 18.9845 3.58667 18.5229 3.93999 18.3067C4.29332 18.0905 4.75499 18.2017 4.97118 18.555C5.17866 18.8941 5.50497 19.0936 5.87571 19.0936H7.24571C7.8011 19.0936 8.25 18.644 8.25 18.0893C8.25 17.6284 7.93612 17.2257 7.48811 17.1122C7.48795 17.1122 7.48826 17.1123 7.48811 17.1122L5.14583 16.5238C4.03437 16.2444 3.25 15.2422 3.25 14.0921C3.25 12.709 4.36958 11.5902 5.75 11.5879V11.0893C5.75 10.6751 6.08579 10.3393 6.5 10.3393ZM11.2508 13.5006C11.2509 13.0864 11.5866 12.7506 12.0009 12.7506L15.0021 12.7507C15.4163 12.7507 15.7521 13.0865 15.7521 13.5008C15.7521 13.915 15.4163 14.2507 15.0021 14.2507L12.0008 14.2506C11.5866 14.2506 11.2508 13.9148 11.2508 13.5006ZM11.2508 16.5018C11.2509 16.0876 11.5866 15.7519 12.0009 15.7519L15.0021 15.752C15.4163 15.752 15.7521 16.0878 15.7521 16.502C15.7521 16.9162 15.4163 17.252 15.0021 17.252L12.0008 17.2519C11.5866 17.2519 11.2508 16.9161 11.2508 16.5018Z"
      />
    </svg>
  );
};

export const AttributionDashboardIcon: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))"
}) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.83333 3C3.37281 3 3 3.37281 3 3.83333V13.1667C3 13.6272 3.37281 14 3.83333 14H13.1667C13.6272 14 14 13.6272 14 13.1667V3.83333C14 3.37281 13.6272 3 13.1667 3H3.83333ZM2 3.83333C2 2.82052 2.82052 2 3.83333 2H13.1667C14.1795 2 15 2.82052 15 3.83333V13.1667C15 14.1795 14.1795 15 13.1667 15H3.83333C2.82052 15 2 14.1795 2 13.1667V3.83333ZM7.16667 5.33333C7.35605 5.33333 7.52918 5.44033 7.61388 5.60973L9.8502 10.0824L10.832 8.2626C10.9192 8.10084 11.0882 8 11.272 8H12.5C12.7761 8 13 8.22386 13 8.5C13 8.77614 12.7761 9 12.5 9H11.5704L10.2734 11.4041C10.1848 11.5683 10.0121 11.6695 9.82556 11.6666C9.63899 11.6637 9.46956 11.5572 9.38612 11.3903L7.16667 6.95137L6.28055 8.72361C6.19585 8.893 6.02272 9 5.83333 9H4.5C4.22386 9 4 8.77614 4 8.5C4 8.22386 4.22386 8 4.5 8H5.52432L6.71945 5.60973C6.80415 5.44033 6.97728 5.33333 7.16667 5.33333Z"
      fill={fill}
    />
  </svg>
);
